import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_MEMBERS_ENDPOINT } from '@/services/org-admin';
import type { OrgMemberListResponse } from '@/services/org-admin';

export function useOrgMembers() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-members', orgId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgMemberListResponse>(ORG_MEMBERS_ENDPOINT(orgId!));
      return data.members;
    },
    enabled: !!orgId,
  });
}
